import React, { FC } from 'react';

import { MoreMenuButton } from '@modernloop/shared/components';
import { Box, MenuItem, Stack, Typography } from '@mui/material';

type MenuOption = {
  id: string;
  value: string;
};

type Props = {
  children?: React.ReactNode;
  title: string;
  icon: React.ReactNode;
  moreMenuOptions?: MenuOption[];
  onSelect?: () => void;
};

const RequirementContainer: FC<Props> = ({ title, icon, moreMenuOptions, onSelect, children }) => {
  return (
    <Stack direction="row" spacing={1} sx={{ minWidth: 0 }}>
      <Box display="flex" alignItems="center" height="28px">
        {icon}
      </Box>
      <Stack sx={{ flexGrow: 1, minWidth: 0 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ height: '28px' }}>
          <Typography variant="body2" color="text.secondary" fontWeight={600}>
            {title}
          </Typography>
          {moreMenuOptions && onSelect && (
            <MoreMenuButton>
              {moreMenuOptions.map((option) => (
                <MenuItem key={option.id} onClick={onSelect}>
                  {option.value}
                </MenuItem>
              ))}
            </MoreMenuButton>
          )}
        </Stack>
        {children}
      </Stack>
    </Stack>
  );
};

export default RequirementContainer;
